import { render, staticRenderFns } from "./ModalContentTransactionIncome.vue?vue&type=template&id=850b7ab8&"
import script from "./ModalContentTransactionIncome.vue?vue&type=script&lang=js&"
export * from "./ModalContentTransactionIncome.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentTransactionIncome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports